import { useQuery } from "@tanstack/react-query";
import { signalKeys } from "@/lib/query";
import type { SignalCatalogStats, SignalStatsWindow } from "@/lib/signal-stats";

async function jsonFetch<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Request failed: ${res.status}`);
  }
  return (await res.json()) as T;
}

export function useSignalCatalogStats(window: SignalStatsWindow) {
  return useQuery({
    queryKey: signalKeys.stats(window),
    queryFn: () => jsonFetch<SignalCatalogStats>(`/api/signals/stats?window=${window}`),
  });
}
